import type { User } from 'src/types/user.types';

// An empty-string tag value makes OneSignal delete the tag, so absent values yield no key.
export const familyFirstLessonTag = (user: User): Record<string, string> => {
  const value = user.family_first_lesson_at;
  if (typeof value !== 'number' || !Number.isInteger(value) || value <= 0) {
    return {};
  }
  return { family_first_lesson_at: String(value) };
};
